// src/pages/SystemSettings.js

import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Label } from 'reactstrap';
import settingService from 'services/setting.service';

const SystemSettings = () => {
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState({});

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const res = await settingService.getAll();
            if (res.data?.success) {
                setSettings(res.data.settings);
            }
        } catch (err) {
            console.error('Lỗi lấy cài đặt:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleToggle = async (key, currentValue) => {
        const newValue = !currentValue;
        setUpdating(prev => ({ ...prev, [key]: true }));
        try {
            const res = await settingService.update(key, newValue);
            if (res.data?.success) {
                setSettings(prev =>
                    prev.map(s => s.key === key ? { ...s, value: newValue } : s)
                );
            }
        } catch (err) {
            console.error('Lỗi cập nhật:', err);
        } finally {
            setUpdating(prev => ({ ...prev, [key]: false }));
        }
    };

    const handleSettingChange = async (key, newValue) => {
        setUpdating(prev => ({ ...prev, [key]: true }));
        try {
            const res = await settingService.update(key, newValue);
            if (res.data?.success) {
                setSettings(prev =>
                    prev.map(s => s.key === key ? { ...s, value: newValue } : s)
                );
            }
        } catch (err) {
            console.error('Lỗi cập nhật:', err);
        } finally {
            setUpdating(prev => ({ ...prev, [key]: false }));
        }
    };

    const getSetting = (key) => settings.find(s => s.key === key);

    if (loading) {
        return (
            <div className="content" style={{ display: 'flex', justifyContent: 'center', paddingTop: '60px' }}>
                <div style={{ color: '#888', fontSize: '18px' }}>
                    <i className="fas fa-sync-alt fa-spin" style={{ marginRight: '8px' }}></i>
                    Đang tải cài đặt...
                </div>
            </div>
        );
    }

    const invoiceSetting = getSetting('invoiceEnabled');
    const webToolSetting = getSetting('webToolMode');
    const webToolMode = webToolSetting?.value || 'account';

    const webToolOptions = [
        { value: 'all', label: 'Bật cho tất cả', color: '#2dce89' },
        { value: 'account', label: 'Bật theo tài khoản', color: '#fb6340' },
        { value: 'none', label: 'Tắt tất cả', color: '#f5365c' }
    ];

    const currentWebToolOption = webToolOptions.find(o => o.value === webToolMode) || webToolOptions[1];

    return (
        <div className="content">
            <style>{`
                .setting-switch {
                    position: relative;
                    display: inline-block;
                    width: 50px;
                    height: 26px;
                    flex-shrink: 0;
                }
                .setting-switch input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                }
                .setting-switch .slider {
                    position: absolute;
                    cursor: pointer;
                    inset: 0;
                    background: #ccc;
                    border-radius: 26px;
                    transition: 0.3s;
                }
                .setting-switch .slider:before {
                    content: "";
                    position: absolute;
                    height: 20px;
                    width: 20px;
                    left: 3px;
                    bottom: 3px;
                    background: #fff;
                    border-radius: 50%;
                    transition: 0.3s;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
                }
                .setting-switch input:checked + .slider {
                    background: #51cbce;
                }
                .setting-switch input:checked + .slider:before {
                    transform: translateX(24px);
                }
                .setting-switch input:disabled + .slider {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
                .radio-option {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 8px 14px;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: all 0.2s;
                    border: 2px solid transparent;
                    user-select: none;
                }
                .radio-option:hover {
                    background: #f0f2f5;
                }
                .radio-option.active {
                    background: #f0f7ff;
                    border-color: currentColor;
                }
                .radio-option input[type="radio"] {
                    accent-color: currentColor;
                    width: 16px;
                    height: 16px;
                    cursor: pointer;
                }
                .radio-option.disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                    pointer-events: none;
                }
            `}</style>

            <Row>
                <Col md="6" lg="4">
                    <Card style={{
                        borderRadius: '20px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        border: 'none',
                        overflow: 'hidden'
                    }}>
                        <CardHeader style={{
                            background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                            padding: '20px 24px',
                            borderBottom: 'none'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <i className="fas fa-globe" style={{
                                    fontSize: '32px',
                                    color: '#fff',
                                    opacity: 0.9
                                }}></i>
                                <div style={{ lineHeight: '1.3' }}>
                                    <Label style={{
                                        fontSize: '18px',
                                        color: '#fff',
                                        fontWeight: '700',
                                        marginBottom: '0',
                                        display: 'block'
                                    }}>
                                        id.dhbtools.com
                                    </Label>
                                    <span style={{
                                        fontSize: '13px',
                                        color: 'rgba(255,255,255,0.7)'
                                    }}>
                                        Trang thanh toán / đăng ký
                                    </span>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody style={{ padding: '20px 24px' }}>
                            {/* Invoice toggle */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '12px 16px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '20px',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <i className="fas fa-file-alt" style={{
                                        fontSize: '18px',
                                        color: invoiceSetting?.value ? '#51cbce' : '#aaa'
                                    }}></i>
                                    <div>
                                        <div style={{
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            color: '#2c3e50'
                                        }}>
                                            Xuất hóa đơn
                                        </div>
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#8898aa',
                                            marginTop: '2px'
                                        }}>
                                            {invoiceSetting?.value
                                                ? 'Đang bật — Người dùng có thể yêu cầu xuất HĐĐT'
                                                : 'Đang tắt — Ẩn chức năng xuất hóa đơn'}
                                        </div>
                                    </div>
                                </div>
                                <label className="setting-switch" style={{ marginBottom: 0 }}>
                                    <input
                                        type="checkbox"
                                        checked={invoiceSetting?.value || false}
                                        disabled={updating['invoiceEnabled']}
                                        onChange={() => handleToggle('invoiceEnabled', invoiceSetting?.value)}
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>

                            {/* WebTool mode */}
                            <div style={{
                                marginTop: '16px',
                                padding: '12px 16px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '20px',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                                    <i className="fas fa-desktop" style={{
                                        fontSize: '18px',
                                        color: currentWebToolOption.color
                                    }}></i>
                                    <div>
                                        <div style={{
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            color: '#2c3e50'
                                        }}>
                                            DHBStreamPro — WebTool
                                        </div>
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#8898aa',
                                            marginTop: '2px'
                                        }}>
                                            Quản lý stream trên web
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {webToolOptions.map(opt => (
                                        <label
                                            key={opt.value}
                                            className={`radio-option ${webToolMode === opt.value ? 'active' : ''} ${updating['webToolMode'] ? 'disabled' : ''}`}
                                            style={{ color: opt.color }}
                                        >
                                            <input
                                                type="radio"
                                                name="webToolMode"
                                                checked={webToolMode === opt.value}
                                                disabled={updating['webToolMode']}
                                                onChange={() => handleSettingChange('webToolMode', opt.value)}
                                            />
                                            <span style={{ fontSize: '14px', fontWeight: '500', color: '#2c3e50' }}>
                                                {opt.label}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default SystemSettings;
